module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-ace.9c6c67d7.svg";